// src/i18n/locales/vietrro-en.ts

export default {
  common: {
    // Brand message
    brandMessage: "Protecting Copyright is protecting \ncreativity and development",
    brandName: "VIETRRO",
    author: "Author",
    author_other: "Authors",
    work: "Work",
    work_other: "Works",
    certificate: "Certificate",
    certificate_other: "Certificates",
    category: "Category",
    category_other: "Categories",
    hashtag: "Tag",
    hashtag_other: "Tags",
    hashtagNote: "separate with commas",
    other: "Other",
    file: "File",
    file_other: "Files",
    violationReport: "Violation report",
    dataInputEmpty: "No data",
    dataEmpty: "No {{topic}}",
    noDataTopic: "No {{topic}} available",
    firstWork: "Create your first work",
    notFound: "{{topic}} not found",
    selectTopic: "Select {{topic}}",
    paginationShow: "Showing {{count}} of {{total}} {{topic}}",
    error: "Error",
    no: "No",
    yes: "Yes",
    protected: "Protected",
    hasThumbnail: "Has thumbnail",
    joinedDate: "Joined",
    all: "All",
    search: "Search",
    searchPlaceholder: "Enter a keyword...",
    searchPlaceholderTopic: "Search {{topic}}...",
    filter: "Filter",
    publishedMarketplace: "Published on Marketplace",
    unpublishedMarketplace: "Unpublished on Marketplace",
    publishedMarketplaceShort: "Marketplace",
    unpublishedMarketplaceShort: "Unpublished",
    homePage: "Home",
    returnWorksPage: "Back to list",
    classification: "Classification",
    publicDisplay: "Display Publicly",
    allowPublicDisplay: "Allow this work to be displayed in the public catalog",
    uploadDescription: "Drag and drop files here or click to browse",
    uploadFormats: "Supported: JPEG, PNG, GIF, MP3, MP4, PDF, DOC, TXT (max 100MB)",
    upLoading: "Uploading...",
    upLoadSuccess: "Upload successful!",
    selectedTopic: "{{topic}} selected",
    deleting: "Deleting...",
    type: "Type",
    status: "Status",
    filterApply: "Filter Applied",
    filterApply_other: "Filters Applied",
    userProfile: "User Profile",
    setting: "Setting",
    setting_other: "Settings",
    overview: "Overview",
    request: "Request",
    request_other: "Requests",
    analytic: "Analytic",
    analytic_other: "Analytics",
    earning: "Earning",
    earning_other: "Earnings",
    newNotification: "New notification",
    newNotification_other: "New notifications",
    character: "Character",
    minimum: "Minimum",
    maximum: "Maximum",
    popular: "Popular",
    price: "Price",
    priceSuggest: "Suggested Price",
    durationUnit: "Days",
    topicLoading: "Loading {{topic}}...",
    content: "Content",
    filterTopicEmpty: "No {{topic}} found matching your search",
    vietrroCertificate: 'Vietrro Certificate',
    wipoCertificate: 'WIPO Certificate',
    noipCertificate: 'NOIP Certificate',
    associationCertificate: 'Association Certificate',
    downloadCertificate: 'Download certificate',
    certificateType: 'Certificate Type',
    issueDate: "Issue Date",
    expiryDate: "Expiry Date",
    description: "Description",
    actions: "Actions",
    copyLink: "Copy link",
    copied: "Copied",
    share: "Share",
    detail: "Details",
    undefined: "Undefined",
    owner: "Owner",
    ownership: "Ownership",
    noDescription: "No description",

    support: {
      pageNotFound: {
        title: "Page not found",
        subTitle: "Sorry, you can’t view this content right now.",
      },
      pageError: {
        title: "Access denied", // "Unauthorized",
        subTitle: "Your session has expired or you do not have permission to view this page. \nPlease sign in again to continue."
      },
      message: "If you believe there’s an issue, please contact us for assistance.",
    },

    button: {
      next: "Next",
      back: "Back",
      changePassword: "Change Password",
      sendResetLink: "Send Reset Link",
      login: "Sign-in",
      signInNow: "Sign-in now",
      backToLogin: "Back to Sign-in",
      contactSupport: "Contact Support",
      backToHome: "Back to Home",
      goBack: "Go Back",
      register: "Create Account",
      joinNow: "Join now",
      registerNow: "Register now",
      processing: "Processing...",
      loading: "Loading...",
      registerWork: "Register Work",
      registerNewWork: "Register a new Work",
      registerWorkNow: "Register Work now",
      discoverMarketplace: "Explore Marketplace",
      marketplace: "Marketplace",
      viewAll: "View all",
      viewAllTopic: "View all {{topic}}s",
      viewDetail: "View detail",
      viewProfile: "View profile",
      refresh: "Refresh",
      uploadButton: "Select Files",
      remove: "Remove",
      cancel: "Cancel",
      cancelRemove: "Cancel deletion",
      addTopic: "Add {{topic}}",
      freeRegister: "Free Registration",
      learnMore: "Learn More",
      exportData: "Download",
      deleteSelected: "Delete selected",
      deselect: "Deselect",
      viewFile: "View file",
      willBeRemove: "Will be deleted",
      addNewFiles: "Add New Files",
      saveChanges: "Save changes (v{{ver}})",
      create: "Create",
      publishToMarketplace: "Publish to Marketplace",
      removeFromMarketplace: "Remove from Marketplace",
      verify: "Verify",
      download: "Download",
      edit: "Edit",
    },
    contentKind: {
      label: "Content type",
      image: "Image",
      video: "Video",
      audio: "Audio",
      text: "Text",
      other: "Other",
    },
    contentStatus: {
      label: "Status",
      draft: "Draft",
      submitted: "Submitted",
      pending: "Pending",
      under_review: "Under review",
      approved: "Approved",
      rejected: "Rejected",
      revision_required: "Revision required",
      published: "Published",
      suspended: "Suspended",
      deleted: "Deleted",
      archived: "Archived",
    },
    sortBy: {
      label: "Sort",
      title: "Title",
      registrationDate: "Registration date",
      licenseCount: "License count",
      viewCount: "View count",
      protectionScore: "Protection score",
    },
    userStatus: {
      verified: "✓ Verified",
      Unverified: "⏳ Unverified",
    },
    title: {
      imageProtection: "Image protection",
      collaborator: "Collaborator",
    },
    watermark: {
      ownerView: "The owner will see the original image without a watermark.",
      applied: "The image will be watermarked with \"tacquyen.vn + VIETRRO\" to protect copyright.",
    },
    footer: {
      description: "A comprehensive solution for protecting copyright and identity for content creators.",
      termsOfUse: "Terms of Use",
      privacyPolicy: "Privacy Policy",
      legal: "Legal",
      sitemap: "Sitemap",
      copyright: "© 2025 Vietrro. All rights reserved.",
      feature: {
        title: "Features",
        identityProtection: "Identity Protection",
        copyrightMonitoring: "Copyright Monitoring",
        autoDMCA: "Automated DMCA",
        aiUsageDetection: "AI Usage Detection",
        marketplace: "Marketplace"
      },
      support: {
        title: "Support",
        helpCenter: "Help Center",
        community: "Community",
        contactSupport: "Contact Support",
        faq: "Frequently Asked Questions",
        resources: "Resources"
      },
      aboutUs: {
        title: "About Us",
        aboutUs: "Introduction",
        careers: "Careers",
        blog: "Blog",
        press: "Press",
        partners: "Partners"
      }
    },
    message: {
      confirmCancelMessage: "Are you sure you want to discard your changes?",
      updateTopicFailMessage: `Failed to update {{topic}}!`,
      confirmDeleteContent: {
        title: "Confirm deletion",
        message: "Are you sure you want to delete this content?",
        description: "This action cannot be undone."
      }
    },
    notifications: {
      title: "Notifications",
      markAllAsRead: "Mark all",
    },
  },
  userGroup: {
    primaryUsers: {
        name: "Primary Users",
        description: "Includes: Copyright Owners, Copyright Users, Copyright Agents",
    },
    educationUsers: {
        "name": "Education Users",
        "description": "General group for all users of the education module",
    },
    teachers: {
        "name": "Teachers",
        "description": "Teacher group with rights to upload and manage materials",
    },
    supportMonitoring: {
        "name": "Support & Monitoring Users",
        "description": "Includes: Legal Team, Copyright Review & Enforcement Department",
    },
    students: {
        "name": "Students",
        "description": "Group for students and pupils",
    },
    guestBusinessPartners: {
        "name": "Guest & Business Partners",
        "description": "Includes: Guest Customers, Technology & Business Partners",
    },
    contentApiManagement: {
        "name": "Content Management & API Integration",
        "description": "Includes: Content Moderators, Content Managers, API Integration Developers, Management & Distribution Partners",
    },
    specialQualityManagement: {
        "name": "Special Users & Quality Management",
        "description": "Includes: Content Reviewers, VIP Users, Copyright Investors",
    },
    independentIndustryExperts: {
        "name": "Independent Users & Industry Experts",
        "description": "Includes: Freelance Content Creators, Copyright Industry Experts, AI Content Moderation Developers",
    },
    educationTraining: {
        "name": "Education & Training",
        "description": "Includes: Copyright Educators, Academic Users",
    },
    legalTeamEx: {
        "name": "Customer Support",
        "description": "Includes: Support Specialists, Onboarding Experts",
    }
  },

  pageContent: {
    login: {
      // Page metadata
      pageTitle: "System Login | Vietrro",
      pageDescription: "Vietrro, comprehensive copyright management platform.",
      pageKeywords: "register, login, vietrro, sign up, sign in, create account",

      // Main content
      title: "Sign In",
      subtitle: "Please sign in to explore full features and \nutilities exclusively for members.",
      
      // Form fields
      username: "Username",
      password: "Password",
      usernamePlaceholder: "Username",
      passwordPlaceholder: "Password",

      // Form actions
      rememberMe: "Remember me",
      forgotPassword: "Forgot password?",
      loginButton: "Sign In",
      loginButtonLoading: "Signing in...",

      // Navigation
      noAccount: "Don't have an account?",
      registerNow: "Sign up now",

      // Messages
      loginSuccess: "Login successful",
      ValidationError: "Invalid login credentials",
      requiredFields: "Please fill in all required fields",
      networkError: "Network connection error, please try again",      
    },
    register: {
      // Page metadata
      pageTitle: "Create Account | Vietrro",
      pageDescription: "Vietrro, comprehensive copyright management platform.",
      pageKeywords: "register, login, vietrro, sign up, sign in, create account",

      // Main content
      title: "Create Vietrro Account",
      subtitle: "Create a new account to manage copyrights",
      alreadyHaveAccount: "Already have an account?",

      // Steps
      steps: {
        selectRole: "Select Role",
        personalInfo: "Personal Information",
        confirm: "Confirm"
      },

      // Step 1 - Role Selection
      roleSelection: {
        title: "Choose your role in the system",
        multipleRolesSwitch: "Select multiple roles",
        selectedRoles: "Selected roles:",
        noRolesSelected: "No roles selected",
        noGroupsAvailable: "No user groups available for registration."
      },

      // Step 2 - Personal Information
      personalInfo: {
        title: "Personal Information",
        firstName: "First Name",
        lastName: "Last Name",
        username: "Username",
        email: "Email",
        phone: "Phone Number",
        password: "Password",
        confirmPassword: "Confirm Password",
        
        // Business fields
        businessInfo: "Organization Information",
        organization: "Organization/ Company",
        taxId: "Tax ID"
      },

      // Step 3 - Confirmation
      confirmation: {
        title: "Confirm Information",
        role: "Role:",
        fullName: "Full Name:",
        specificRoles: "Specific Roles:",
        approvalNote: "Your account will need to be approved before you can use all features.",
        approvalNoteTitle: "Note:",
        agreeTerms: "I agree to the",
        termsOfUse: "Terms of use",
        and: "and",
        privacyPolicy: "privacy policy",
        ofVietrro: "of Vietrro"
      },

      // Messages
      messages: {
        loading: "Loading...",
        loadingInfo: "Loading information...",
        dataLoadError: "Unable to load data. Please try again later",
        usernameExists: "Username already exists or is invalid, please choose another",
        emailInvalid: "Email is invalid, please choose another email",
        registrationFailed: "Registration failed. Please try again."
      },

      // Validation messages
      validation: {
        selectAtLeastOneRole: "Please select at least one role",
        firstNameRequired: "Please enter first name",
        lastNameRequired: "Please enter last name",
        usernameRequired: "Please enter username",
        usernameMinLength: "Username must be at least 4 characters",
        usernameMaxLength: "Username can be at most 30 characters",
        usernameExists: "Username already exists or is invalid",
        emailRequired: "Please enter email",
        emailInvalid: "Email already exists or is invalid",
        passwordRequired: "Please enter password",
        passwordMinLength: "Password must be at least 8 characters",
        confirmPasswordRequired: "Please confirm password",
        passwordMismatch: "Password confirmation does not match",
        phoneInvalid: "Phone number already exists or is invalid",
        agreeTermsRequired: "Please agree to the terms of use"
      },

      
    },
    forgotPassword: {
      // Page metadata
      pageTitle: "Password Recovery | Vietrro",
      pageDescription: "Vietrro, comprehensive copyright management platform.",
      pageKeywords: "register, login, vietrro, sign up, sign in, create account",

      // Brand
      brandMessage: "Protecting Copyright is protecting \ncreativity and development",
      brandName: "VIETRRO",

      // Main content
      title: "Reset Password",
      subtitle: "For security reasons, please confirm your information \nso we can help you reset your password.",

      // Form fields
      emailLabel: "Registered Email",
      emailPlaceholder: "Enter your email",
      newPasswordLabel: "New Password",
      newPasswordPlaceholder: "Enter new password",
      confirmPasswordLabel: "Confirm Password",
      confirmPasswordPlaceholder: "Confirm new password",
      otpLabel: "OTP Code",
      otpPlaceholder: "Enter OTP",

      // Messages
      processing: "Processing...",
      success: "Success!",
      successMessage: "Your password has been changed successfully. \nPlease sign in to continue",
      otpSentSuccess: "Verification code has been sent \nto your email!",
      resetLinkSent: "Password reset link has been sent \nto your email!",
      
      // Error messages
      otpSendError: "Unable to send verification code. \nPlease check your information and try again.",
      passwordMismatch: "Passwords do not match! \nPlease check your information and try again.",
      otpVerifyError: "OTP verification failed",
      generalError: "An error occurred. Please try again later.",

      // Navigation
      rememberPassword: "Remember your password?",
    },
    home: {
      // Page metadata
      pageTitle: "Vietrro - Copyright Protection Platform",
      pageDescription: "Vietrro is a comprehensive copyright protection platform that helps creators protect, manage, and monetize their intellectual property with advanced AI-powered monitoring and legal enforcement tools.",
      pageKeywords: "copyright protection, intellectual property, content protection, AI monitoring, legal enforcement, digital rights management, creator protection, content licensing",

      // Hero Section
      hero: {
        title: "Protect Your Creative Works",
        subtitle: "A comprehensive solution for copyright protection and online identity management",
        description: "Join thousands of creators who trust Vietrro to protect, manage, and monetize their intellectual property with cutting-edge technology and comprehensive legal support.",
        protectedWorks: "Protected Works",
        activeUsers: "Trusted Authors",
      },

      // Recent Works Section
      recentWorks: {
        title: "Recently Protected Works",
        subtitle: "Latest content added to our protection system",
        description: "Discover the most recent creative works that have been registered and protected through our platform.",
        viewAll: "View All Works",
        noWorks: "No protected works available at the moment",
        loading: "Loading recent works...",
        workCard: {
          protectedOn: "Protected on",
          by: "by",
          category: "Category",
          viewDetails: "View Details",
          downloadCertificate: "Download Certificate"
        },
        filters: {
          all: "All Works",
          documents: "Documents",
          images: "Images",
          videos: "Videos",
          audio: "Audio",
          software: "Software"
        }
      },

      // Featured Users Section
      featuredUsers: {
        title: "Featured Authors",
        subtitle: "Featured Authors in the Vietrro community",
        description: "Meet our talented community of creators who are actively protecting their intellectual property.",
        viewAll: "View All Creators",
        totalFeaturedAuthors: "({{total}}) featured Authors",
        totalOwnership: "({{total}}) Ownership",
        totalPrimaryUsers: "({{total}}) Primary users",
        totalVerifiedUsers: "({{total}}) Verified users",
        noUser: {
          title: "No featured users available",
          subtitle: "Check back soon to discover talented creators"
        },
        loading: "Loading featured creators...",
        userCard: {
          member: "Member",
          since: "since",
          works: "works",
          certificates: "certificates",
          viewProfile: "View Profile",
          contact: "Contact"
        },
        stats: {
          totalWorks: "Total Works",
          activeCertificates: "Active Certificates",
          joinedDate: "Joined",
          lastActive: "Last Active"
        },
        action: {
          title: "Are you an author too?",
          subtitle: "Join the Vietrro community to share your works and connect with other creators"
        }
      },

      // Active Certificates Section
      activeCertificates: {
        title: "Copyright Certificates",
        title2: "under protection",
        subtitle: "Track and manage your active copyright certificates, \nensuring your works are fully protected.",
        noteNoCertificates: "Start protecting your work by registering for copyright certification today.",
        stat: {
          total: "Total",
          vietrro: "Vietrro",
          wipo: "WIPO",
        },
        action: {
          title: "Comprehensive Protection for Your Work",
          subtitle: "Register your copyright certificates with trusted organizations \nto ensure your creations are fully protected against any infringement."
        },
        highlight: {
          autoProtect: {
            title: "Automatic Protection",
            subtitle: "AI-powered 24/7 monitoring to detect copyright infringements"
          },
          international: {
            title: "International Protection",
            subtitle: "Certificates recognized in over 190 countries worldwide"
          },
          valueIncrease: {
            title: "Value Enhancement",
            subtitle: "Certificates help increase the commercial value of your work"
          }
        }
      },

      // Recent Violations Section
      recentViolations: {
        title: "Recent Violation Reports",
        subtitle: "Latest copyright infringement cases reported",
        description: "Monitor recent copyright violation reports and enforcement actions.",
        viewAll: "View All Reports",
        reportViolation: "Report Violation",
        noViolations: "No violation reports available",
        loading: "Loading violation reports...",
        violationCard: {
          reportId: "Report ID",
          reportedOn: "Reported on",
          work: "Work",
          reporter: "Reporter",
          status: "Status",
          priority: "Priority",
          viewDetails: "View Details",
          takeAction: "Take Action"
        },
        status: {
          pending: "Pending",
          investigating: "Under Investigation",
          resolved: "Resolved",
          dismissed: "Dismissed",
          escalated: "Escalated"
        },
        priority: {
          low: "Low",
          medium: "Medium",
          high: "High",
          critical: "Critical"
        }
      },

      // Quick Actions Section
      quickActions: {
        title: "Quick Actions",
        subtitle: "Fast access to commonly used features",
        description: "Streamline your workflow with these frequently used actions.",
        actions: {
          uploadWork: {
            title: "Register Your Work",
            description: "Register your creative works to secure copyright protection and verify your legal ownership.",
            cta: "Register Now"
          },
          marketplace: {
            title: "Buy/Sell Licenses",
            description: "Explore the copyright marketplace where creators and businesses can easily trade, transfer, or license works.",
            cta: "Explore Now"
          },
          reportViolation: {
            title: "Report Violations",
            description: "Participate in promptly reporting unauthorized use or copyright infringements of protected works.",
            cta: "Report Now"
          },
          identityProtection: {
            title: "Protect Your Identity",
            description: "Safeguard your personal image, identity, and creative brand in the digital space.",
            cta: "Join Now"
          }
        }
      },

      // Statistics Section
      stats: {
        title: "System Statistics",
        subtitle: "Trust in numbers - our impact on copyright protection",
        description: "See how Vietrro is making a difference in protecting intellectual property worldwide.",
        counters: {
          totalUsers: {
            value: "50,000+",
            label: "Registered Authors",
            description: "Creators trusting our platform"
          },
          protectedWorks: {
            value: "500,000+",
            label: "Protected Works",
            description: "Creative works under protection"
          },
          detectedViolations: {
            value: "25,000+",
            label: "Violations Successfully Prevented",
            description: "Copyright infringements caught"
          },
          copyrightValueProtected: {
            value: "15.2B VND",
            label: "Copyright Value Protected",
            description: "Vi phạm bản quyền đã bị ngăn chặn"
          },
          successRate: {
            value: "98%",
            label: "Success Rate",
            description: "Successful enforcement actions"
          },
          countriesCovered: {
            value: "180+",
            label: "Countries Covered",
            description: "Global copyright protection"
          },
          aiScans: {
            value: "1M+",
            label: "AI Scans Daily",
            description: "Automated monitoring scans"
          }
        },
        viewDetailedStats: "View Detailed Statistics"
      },

      // Call to Action Section
      cta: {
        
        title: "Ready to protect your Work?",
        subtitle: "Join thousands of authors who trust Vietrro to safeguard their intellectual property",
        description: "Start protecting your creative works today with our comprehensive copyright protection platform. Get started in minutes with our easy-to-use tools and AI-powered monitoring.",
        features: {
          aiMonitoring: "AI-Powered Monitoring",
          legalSupport: "Legal Support",
          globalCoverage: "Global Coverage",
          easyToUse: "Easy to Use"
        },
        buttons: {
          getStarted: "Get Started Free",
          viewPricing: "View Pricing",
          bookDemo: "Book a Demo",
          learnMore: "Learn More"
        },
        guarantees: {
          freeTrial: "14-day free trial",
          noSetupFee: "No setup fees",
          cancelAnytime: "Cancel anytime"
        }
      },

      // Common elements
      common: {
        loading: "Loading...",
        error: "An error occurred while loading data",
        retry: "Retry",
        noData: "No data available",
        viewMore: "View More",
        viewLess: "View Less",
        showAll: "Show All",
        hideAll: "Hide All",
        search: "Search...",
        filter: "Filter",
        sort: "Sort",
        date: "Date",
        name: "Name",
        status: "Status",
        actions: "Actions"
      },

      // Error states
      errors: {
        loadingWorks: "Failed to load recent works",
        loadingUsers: "Failed to load featured users",
        loadingCertificates: "Failed to load certificates",
        loadingViolations: "Failed to load violation reports",
        general: "Something went wrong. Please try again later."
      }

    },
    
  }
}
